import {
  createFeatureIntroSeen,
  FeatureIntroSeenState
} from 'components/FeatureIntro/featureIntroSeen';

/**
 * "Seen" for the one-time multi-run introduction (EN-10791).
 *
 * Written when the PLAYER dismisses the modal (×, a button, Escape, a backdrop
 * tap after the guard) — never when it merely paints, and never on a teardown
 * (location going invalid, the flag turning off, a clock starting at a table),
 * because AC-9.2 reads "after dismissal, never again".
 *
 * Keyed by EDITION and playerGUID:
 *   - per edition, so each announcement is its own one-time showing: a player
 *     who dismissed `nlhe-launch` still sees `omaha-live` once (Jason,
 *     2026-09-28). The edition id is validated at the flag boundary
 *     (lower-case letters, digits, dashes), so it is safe inside the key.
 *   - per player, the LaunchDarkly convention for any client preference a
 *     flagged behavior stores, so a shared device never passes one player's
 *     dismissal to another.
 *
 * Best effort, per install: the web app and the native app keep separate
 * storage, and iOS may reclaim WebView storage. Server-side persistence is a
 * follow-up only if cross-device repeats draw complaints.
 */
export const MULTI_RUN_INTRO_SEEN_KEY_PREFIX = 'hijack:featureIntro:multiRun:';

/**
 * 'unreadable' fails CLOSED at the call site: if storage cannot be read, the
 * introduction does not show. The promo fails open, which is how a private
 * window gets it on every visit; a one-time announcement must not repeat.
 */
export type MultiRunIntroSeenState = FeatureIntroSeenState;

// The storage shape is shared with the heads-up introduction (EN-10748):
// components/FeatureIntro/featureIntroSeen.ts, under this module's own prefix.
const seen = createFeatureIntroSeen(MULTI_RUN_INTRO_SEEN_KEY_PREFIX);

export const readMultiRunIntroSeen = seen.read;

/** False when storage refused the write; the caller's session guard still holds. */
export const markMultiRunIntroSeen = seen.mark;
